import { createContext } from 'react';
import { NOOP } from '../../utils/const.js';

var SidebarContext = createContext({
    openCallback: NOOP,
    open: false,
});

export { SidebarContext as default };
